import { LogicContext } from '../types';

import models from '../../../model';

import config from '../../../config';
import { getLocale } from '../../../utils';

export const fetchRecentlyPlayedGames = (context: LogicContext) => async () => {
  const authToken = context.user?.authToken?.access_token;

  const getLatestRPGames = async () => {
    const response = authToken
      ? await models.fetchRecentlyPlayed({
          authToken,
          locale: getLocale(config),
          market_country: config.viewer_country,
          market_region: config.viewer_region,
        })
      : { status: 401, data: [] };
    return response;
  };
  const { status, data } = await getLatestRPGames();

  return {
    status,
    recentlyPlayedGamesList: data,
  };
};
